/* eslint-disable max-len */
import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" {...props}>
    <title>Navigation Logo</title>
    <path d="M13.361 2.218C11.682.746 9.516 0 6.926 0H0v.208c0 .984.925 1.849 1.98 1.849h4.738c2.007 0 4.142.69 5.314 1.717 1.251 1.095 1.938 2.594 1.938 4.222v.173c-.329-1.058-.943-2.005-1.775-2.737-1.255-1.112-3.186-1.776-5.166-1.776H2.079v.208c0 .985.925 1.849 1.98 1.849h2.969c2.887 0 5.149 1.806 5.149 4.111 0 1.01-.46 1.982-1.296 2.737-.837.739-1.893 1.185-3.006 1.271-1.289.099-5.548.102-5.591.102h-.209v.208c0 1.042 1.118 1.849 2.08 1.849h3.052c2.335 0 4.518-.788 6.152-2.218C15.062 12.281 16 10.23 16 7.995s-.936-4.286-2.639-5.777z" />
  </svg>
);
